export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/search_perseus/apps/spokesperson_de-DE.719b83e.vtt";